import React from 'react'

/** The inspector's notes + photos of a finding (signed links, http(s) only) - used on the create form and the task detail. */
export const FindingEvidence = ({ notes, photos, size = 64 }) => {
    const urls = (Array.isArray(photos) ? photos : []).filter(u => /^https?:\/\//i.test(u || ''))
    if (!notes && urls.length === 0) return null
    return (
        <>
            {notes && <div style={{ whiteSpace: 'pre-wrap', color: '#374151', fontSize: 12, marginTop: 4 }}>{notes}</div>}
            {urls.length > 0 && (
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
                    {urls.map(u => (
                        <a key={u} href={u} target="_blank" rel="noopener noreferrer">
                            <img src={u} alt="Finding" style={{ width: size, height: size, objectFit: 'cover', borderRadius: 4 }} />
                        </a>
                    ))}
                </div>
            )}
        </>
    )
}
